export const CountryEmptyState = () => (
  <div className="flex h-[280px] min-w-[240px] flex-[1_1_260px] flex-col items-center justify-center gap-3 rounded-12 border border-neutral-100 bg-neutral-25 p-4">
    <div className="flex flex-col items-center justify-center gap-2 text-center">
      <img
        src="/images/talent-charts/countries_chart.png"
        alt="Countries distribution chart"
        className="h-[40px] w-[48px]"
      />
      <p className="text-14 font-500 text-root-text-color-muted">
        Country distribution
      </p>
      <p className="text-12 font-400 text-root-text-color-subtle">
        Audience location estimates are not yet supported for Talent from this
        region. Invite them to connect to view verified metrics.
      </p>
    </div>
  </div>
);
